module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "live-edit",
    on: {
      "click": _vm.textClicked,
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.finalize($event)
      },
      "focusout": _vm.finalize
    }
  }, [(_vm.isEditing) ? _c('el-input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "autofocus": true,
      "placeholder": _vm.placeholder
    },
    on: {
      "blur": _vm.finalize
    },
    model: {
      value: (_vm.modelvalue),
      callback: function($$v) {
        _vm.modelvalue = $$v
      },
      expression: "modelvalue"
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.modelvalue || _vm.placeholder))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6fbeaf43!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveEdit.vue
// module id = 1008
// module chunks = 2